import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AuthService } from '../../../services/auth.service';
import { EnvService } from '../../../services/env.service';
import { CommonService } from '../../../services/common.service';

@Component({
	selector: 'app-userreg',
	templateUrl: './userreg.component.html',
	styleUrls: ['./userreg.component.css']
})
export class UserregComponent implements OnInit {

	frm : FormGroup;

	constructor() { }

	ngOnInit() {
	}

}
